/**
 * @fileoverview Main application component with sensor data display and authentication
 * @requires react
 * @requires react-bootstrap
 * @requires aws-amplify
 */

import React from 'react';
import './App.css';

// Bootstrap imports for layout
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

// Custom components
import Sensors from './components/sensorData';

// AWS Amplify configuration and authentication
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import { withAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { Auth } from 'aws-amplify';

// Configure Amplify with AWS settings
Amplify.configure(awsconfig);

// Verify current authentication credentials
Auth.currentCredentials().then(creds => console.log(creds));

/**
 * @function App
 * @description Main application component that displays sensor data in a responsive grid
 * @param {Object} props - Component properties including signOut function from withAuthenticator
 * @returns {JSX.Element} Rendered application with authentication wrapper
 */
function App({ signOut, user }) {
    return (
        <div className="App">
            <Container className="p-4">
                {/* Header with user info and logout button */}
                <Row className="mb-4 justify-content-between align-items-center">
                    <Col>
                        <h4>Welcome, {user.username}</h4>
                    </Col>
                    <Col xs="auto">
                        <Button 
                            variant="outline-danger" 
                            onClick={signOut}
                        >
                            Sign Out
                        </Button>
                    </Col>
                </Row>

                {/* Sensors display */}
                <Row className="p-3 justify-content-md-center">
                    {/* Time sensor display */}
                    <Col md="auto">
                        <Sensors name="time" unit="s"/>
                    </Col>
                    
                    {/* Temperature sensor display */}
                    <Col md="auto">
                        <Sensors name="temperature" unit="°C"/>
                    </Col>
                    
                    {/* Humidity sensor display */}
                    <Col md="auto">
                        <Sensors name="humidity" unit="%"/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

/**
 * @constant authConfig
 * @description Configuration object for Amplify authenticator
 */
const authConfig = {
    signUpAttributes: ['email'],
    hideSignUp: false,
    loginMechanisms: ['username'],
};

// Export the App component wrapped with AWS Amplify authentication
export default withAuthenticator(App, authConfig);
